export const GLOBAL_UPDATE_STATE = 'GLOBAL_UPDATE_STATE';
export const SET_WIZARD_VALUE = 'SET_WIZARD_VALUE';
export const STEP_UPDATE = 'STEP_UPDATE';
export const SEND_EMAIL_TO_CLIENT = 'SEND_EMAIL_TO_CLIENT';